export type Lang = 'en' | 'ur' | 'ar'

export const t = {
  // Intro slide
  introTitle: {
    en: 'Help your clinic prepare for your visit',
    ur: 'اپنے کلینک کو اپنے دورے کی تیاری میں مدد کریں',
    ar: 'ساعد عيادتك في التحضير لزيارتك',
  },
  introBody1: {
    en: 'Your specialist team would like to understand your symptoms before your appointment.',
    ur: 'آپ کی ماہر ٹیم آپ کی ملاقات سے پہلے آپ کی علامات کو سمجھنا چاہتی ہے۔',
    ar: 'يود فريقك المتخصص فهم أعراضك قبل موعدك.',
  },
  introBody2: {
    en: 'Answering a few short questions helps us provide the best care for you.',
    ur: 'چند مختصر سوالات کے جوابات دینے سے ہمیں آپ کی بہترین دیکھ بھال فراہم کرنے میں مدد ملتی ہے۔',
    ar: 'الإجابة على بعض الأسئلة القصيرة تساعدنا في تقديم أفضل رعاية لك.',
  },
  shortQuestions: {
    en: '3 short questions',
    ur: '۳ مختصر سوالات',
    ar: '٣ أسئلة قصيرة',
  },
  lessThanMinute: {
    en: 'Takes less than a minute',
    ur: 'ایک منٹ سے بھی کم وقت لگتا ہے',
    ar: 'يستغرق أقل من دقيقة',
  },
  start: {
    en: 'Start',
    ur: 'شروع کریں',
    ar: 'ابدأ',
  },

  // Question 1 - Symptom
  q1Question: {
    en: 'Which of these best describes your symptom?',
    ur: 'ان میں سے کون سا آپ کی علامت کو بہترین طریقے سے بیان کرتا ہے؟',
    ar: 'أي من هذه يصف أعراضك بشكل أفضل؟',
  },
  breastPain: {
    en: 'Breast pain',
    ur: 'چھاتی میں درد',
    ar: 'ألم في الثدي',
  },
  breastLump: {
    en: 'Breast lump',
    ur: 'چھاتی میں گانٹھ',
    ar: 'كتلة في الثدي',
  },
  nippleDischarge: {
    en: 'Nipple discharge',
    ur: 'نپل سے رطوبت',
    ar: 'إفرازات من الحلمة',
  },
  q1Info: {
    en: 'These are common reasons patients are referred to a breast clinic.',
    ur: 'یہ عام وجوہات ہیں جن کی بنا پر مریضوں کو بریسٹ کلینک بھیجا جاتا ہے۔',
    ar: 'هذه أسباب شائعة لإحالة المرضى إلى عيادة الثدي.',
  },

  // Location question
  locationQuestion: {
    en: 'Where is the lump located?',
    ur: 'گانٹھ کہاں واقع ہے؟',
    ar: 'أين تقع الكتلة؟',
  },
  leftBreast: {
    en: 'Left breast',
    ur: 'بائیں چھاتی',
    ar: 'الثدي الأيسر',
  },
  rightBreast: {
    en: 'Right breast',
    ur: 'دائیں چھاتی',
    ar: 'الثدي الأيمن',
  },
  bothBreasts: {
    en: 'Both breasts',
    ur: 'دونوں چھاتیاں',
    ar: 'كلا الثديين',
  },

  // Duration question
  durationQuestion: {
    en: 'How long have you noticed this?',
    ur: 'آپ نے یہ کب سے محسوس کیا ہے؟',
    ar: 'منذ متى لاحظت هذا؟',
  },
  lessThanWeek: {
    en: 'Less than 1 week',
    ur: 'ایک ہفتے سے کم',
    ar: 'أقل من أسبوع',
  },
  oneToFourWeeks: {
    en: '1 to 4 weeks',
    ur: '۱ سے ۴ ہفتے',
    ar: 'من أسبوع إلى ٤ أسابيع',
  },
  oneToThreeMonths: {
    en: '1 to 3 months',
    ur: '۱ سے ۳ ماہ',
    ar: 'من شهر إلى ٣ أشهر',
  },
  moreThanThreeMonths: {
    en: 'More than 3 months',
    ur: '۳ ماہ سے زیادہ',
    ar: 'أكثر من ٣ أشهر',
  },

  // Investigations question
  investigationsQuestion: {
    en: 'Have you had investigations for this symptom at another hospital?',
    ur: 'کیا آپ نے اس علامت کے لیے کسی اور ہسپتال میں تحقیقات کروائی ہیں؟',
    ar: 'هل أجريت فحوصات لهذا العرض في مستشفى آخر؟',
  },
  yes: {
    en: 'Yes',
    ur: 'ہاں',
    ar: 'نعم',
  },
  no: {
    en: 'No',
    ur: 'نہیں',
    ar: 'لا',
  },
  notSure: {
    en: 'Not sure',
    ur: 'یقین نہیں',
    ar: 'غير متأكد',
  },

  // Completion
  completionTitle: {
    en: 'Thank you',
    ur: 'شکریہ',
    ar: 'شكراً لك',
  },
  completionBody: {
    en: 'Your responses have been recorded. Your clinic team will review this before your appointment.',
    ur: 'آپ کے جوابات ریکارڈ کر لیے گئے ہیں۔ آپ کی کلینک ٹیم آپ کی ملاقات سے پہلے ان کا جائزہ لے گی۔',
    ar: 'تم تسجيل إجاباتك. سيراجعها فريق العيادة قبل موعدك.',
  },
  finish: {
    en: 'Finish',
    ur: 'مکمل',
    ar: 'إنهاء',
  },
  continue: {
    en: 'Continue',
    ur: 'جاری رکھیں',
    ar: 'متابعة',
  },

  // Reward / insight slides
  insight: {
    en: 'Insight',
    ur: 'معلومات',
    ar: 'معلومة',
  },

  // Lump reward
  lumpInsightTitle: {
    en: 'Most breast lumps are not cancer',
    ur: 'زیادہ تر چھاتی کی گانٹھیں کینسر نہیں ہوتیں',
    ar: 'معظم كتل الثدي ليست سرطانية',
  },
  lumpInsightBody: {
    en: 'Finding a lump can be worrying, but most breast lumps are benign. Your clinic visit will help determine exactly what it is.',
    ur: 'گانٹھ کا پتا چلنا پریشان کن ہو سکتا ہے، لیکن زیادہ تر چھاتی کی گانٹھیں بے ضرر ہوتی ہیں۔ آپ کا کلینک دورہ یہ طے کرنے میں مدد کرے گا کہ یہ بالکل کیا ہے۔',
    ar: 'قد يكون اكتشاف كتلة مقلقاً، لكن معظم كتل الثدي حميدة. ستساعد زيارتك للعيادة في تحديد ماهيتها بالضبط.',
  },
  whatLumpCanBe: {
    en: 'WHAT a breast lump can be',
    ur: 'چھاتی کی گانٹھ کیا ہو سکتی ہے',
    ar: 'ما يمكن أن تكون كتلة الثدي',
  },
  howClinicExamines: {
    en: 'HOW the clinic will examine it',
    ur: 'کلینک اس کا معائنہ کیسے کرے گا',
    ar: 'كيف ستفحصها العيادة',
  },
  whatToBring: {
    en: 'WHAT to bring to your appointment',
    ur: 'اپنی ملاقات میں کیا لائیں',
    ar: 'ماذا تحضر لموعدك',
  },

  // Location reward
  locationInsightTitle: {
    en: 'Your clinic knows where to focus',
    ur: 'آپ کا کلینک جانتا ہے کہ کہاں توجہ دینی ہے',
    ar: 'عيادتك تعرف أين تركز',
  },
  locationInsightBody: {
    en: 'Knowing the location helps your specialist prepare the right examination and imaging for your visit.',
    ur: 'مقام جاننے سے آپ کے ماہر کو آپ کے دورے کے لیے صحیح معائنہ اور امیجنگ تیار کرنے میں مدد ملتی ہے۔',
    ar: 'معرفة الموقع تساعد أخصائيك في تحضير الفحص والتصوير المناسب لزيارتك.',
  },

  // Duration reward
  durationInsightTitle: {
    en: 'Timeline helps your specialist',
    ur: 'وقت کی معلومات آپ کے ماہر کی مدد کرتی ہیں',
    ar: 'الجدول الزمني يساعد أخصائيك',
  },
  durationInsightBody: {
    en: 'Understanding how long you have noticed changes helps your clinic team plan the most appropriate assessment.',
    ur: 'یہ سمجھنا کہ آپ نے کتنے عرصے سے تبدیلیاں محسوس کی ہیں، آپ کی کلینک ٹیم کو سب سے مناسب تشخیص کی منصوبہ بندی میں مدد کرتا ہے۔',
    ar: 'فهم المدة التي لاحظت فيها التغييرات يساعد فريق عيادتك في التخطيط للتقييم الأنسب.',
  },

  // 9 out of 10
  nineOutOfTen: {
    en: 'breast lumps are not cancer',
    ur: 'چھاتی کی گانٹھیں کینسر نہیں ہوتیں',
    ar: 'كتل الثدي ليست سرطانية',
  },
  outOf: {
    en: 'out of',
    ur: 'میں سے',
    ar: 'من',
  },
} as const

export function getText(key: keyof typeof t, lang: Lang): string {
  return t[key][lang] || t[key]['en']
}

export function isRtl(lang: Lang): boolean {
  return lang === 'ur' || lang === 'ar'
}
